import React, { useEffect, useState } from "react";
import { CheckSquare } from "lucide-react";
import Layout, { PageHeader } from "@/components/Layout";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";
import { getNav } from "@/pages/navConfigs";

export default function PrincipalTodosPage() {
  const { user } = useAuth();
  const [events, setEvents] = useState([]);
  const [todos, setTodos] = useState([]);
  const [responses, setResponses] = useState({});

  const load = async () => {
    const [e, t] = await Promise.all([api.get("/events"), api.get("/my-school-todos")]);
    setEvents(e.data);
    setTodos(t.data);
  };
  useEffect(() => { load(); }, []);

  const respond = async (t, payload) => {
    await api.patch(`/school-todos/${t.todo_id}`, payload);
    load();
  };

  const uploadFile = async (t, file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    const r = await api.post("/upload", fd);
    await respond(t, { response_url: `${process.env.REACT_APP_BACKEND_URL}${r.data.url}`, status: "done" });
  };

  return (
    <Layout navItems={getNav("school_principal")}>
      <div className="p-6 lg:p-10 max-w-5xl mx-auto">
        <PageHeader title="School To-Dos" subtitle="Tasks the PM / Regional PM has asked the school to complete" icon={CheckSquare} accent="violet" />

        <div className="space-y-3">
          {todos.length === 0 && <div className="dashboard-card p-12 text-center text-slate-400">No school to-dos right now.</div>}
          {todos.map((t) => {
            const ev = events.find((e) => e.event_id === t.event_id);
            return (
              <div key={t.todo_id} className={`dashboard-card p-5 ${t.status === "done" ? "border-emerald-200 bg-emerald-50/30" : ""}`} data-testid={`p-todo-${t.todo_id}`}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="font-display font-bold text-lg">{t.title}</div>
                    <div className="text-xs text-slate-500 mt-1">For event: {ev?.name || "—"} · Assigned by {t.assigned_by_name}</div>
                    {t.description && <p className="text-sm text-slate-700 mt-2">{t.description}</p>}
                    <div className="mt-2 inline-block px-2 py-0.5 rounded-full text-xs bg-slate-100">Expects: {t.expects}</div>

                    {t.status === "done" ? (
                      <div className="mt-3 p-3 rounded-lg bg-white border border-emerald-100">
                        <div className="text-xs text-emerald-700 font-bold uppercase mb-1">Your response</div>
                        {t.response_text && <div className="text-sm">{t.response_text}</div>}
                        {t.response_url && <a href={t.response_url} target="_blank" rel="noreferrer" className="text-orange-600 underline text-sm">View attachment</a>}
                        <button onClick={() => respond(t, { status: "pending", response_text: "", response_url: "" })} className="ml-3 text-xs text-slate-500 underline">Edit response</button>
                      </div>
                    ) : (
                      <div className="mt-3">
                        {t.expects === "text" && (
                          <div className="flex gap-2">
                            <input className="input-pill text-sm py-2" placeholder="Your answer" value={responses[t.todo_id] || ""} onChange={(e) => setResponses({ ...responses, [t.todo_id]: e.target.value })} data-testid={`p-todo-text-${t.todo_id}`} />
                            <button onClick={() => respond(t, { response_text: responses[t.todo_id] || "", status: "done" })} className="btn-primary py-2 px-3 text-xs">Submit</button>
                          </div>
                        )}
                        {t.expects === "link" && (
                          <div className="flex gap-2">
                            <input className="input-pill text-sm py-2" placeholder="https://…" value={responses[t.todo_id] || ""} onChange={(e) => setResponses({ ...responses, [t.todo_id]: e.target.value })} data-testid={`p-todo-link-${t.todo_id}`} />
                            <button onClick={() => respond(t, { response_url: responses[t.todo_id] || "", status: "done" })} className="btn-primary py-2 px-3 text-xs">Submit</button>
                          </div>
                        )}
                        {t.expects === "file" && (
                          <label className="btn-primary py-2 px-4 text-xs inline-flex cursor-pointer" data-testid={`p-todo-file-${t.todo_id}`}>
                            Upload file
                            <input type="file" className="hidden" onChange={(e) => uploadFile(t, e.target.files?.[0])} />
                          </label>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}
